/* @ngInject */

export default (PRODUCT) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function ProductFee(type, name, description, conditions, value) {
    this.type = type;
    this.name = name;
    this.description = description;
    this.conditions = conditions;
    this.value = value;
  }

  /*
   * Public Methods
   * --------------------------------------------------------------------------------
   */
  ProductFee.prototype.getName = function () {
    return this.name;
  };

  ProductFee.prototype.getFeeType = function () {
    const typeId = this.type;
    const feeType = _.find(PRODUCT.DETAILS.FEE_TYPE, (t) => t.id === typeId);
    return feeType ? feeType.value : 'N/A';
  };

  /*
   * Static Methods
   * --------------------------------------------------------------------------------
   */
  ProductFee.Blank = function () {
    return ProductFee.Build({
      type: '',
      name: '',
      description: '',
      conditions: [],
      value: 0
    });
  };
  ProductFee.Build = function (data) {
    return new ProductFee(data.type, data.name, data.description, data.conditions, data.value);
  };

  return ProductFee;
};
